import { addListener, getNextSibling } from "@grindex-common/helpers/domManipulation";
import ProductTechnicalDrawingsDom from "./productTechnicalDrawings.dom";
import { styleCheckBoxes, unCheck } from "@grindex-common/helpers/styledCheckBox";
import { events } from "@grindex-common/helpers/events";
import { classes } from "@grindex-common/helpers/cssGlobals";
import SearchEventManager from "@grindex-client/components/Search/SearchEventManager.class";
import TabNames from "@grindex-client/components/Tabs/TabNames.class";
import asyncModule from "@grindex-client/components/Module/asyncModule";

(function listenForEvent() {
	asyncModule("productTechnicalDrawings", events.tabLoadedEvent(new TabNames().product.drawings), init);
})();

const EVENT_CLICK = "click";

const CLASS_ICON_OPEN = "icon-open";
const CLASS_ICON_CLOSED = "icon-closed";
const CLASS_OPEN = "open";
const CLASS_GROUP = "group";

function init($views) {
	const $module = $views;

	const dom = new ProductTechnicalDrawingsDom($module);

	const baseUrl =
		`${$module.dataset.apiUrl}?feedtype=${$module.dataset.apiFeedType}` +
		`&productname=${$module.dataset.apiFeedName}&brandpageid=${$module.dataset.apiBrandPage}`;

	var resultTemplate = dom.getDrawingResultTemplate();
	var facetGroupTemplate = dom.getDrawingFacetTemplate();

	var eventManager = new SearchEventManager();

	eventManager.on(events.search.FACET_CLEAR_ALL, clearSelectedFacets, true);
	eventManager.on(events.search.SEARCH, fetchResults, true);

	fetchResults();

	function initEvents() {
		addListener(dom.getStyledCheckbox(), EVENT_CLICK, fetchResults);
		addListener(dom.getFacetGroupHeader(), EVENT_CLICK, filterToggle);
		addListener(dom.getFilterSmallDeviceToggle(), EVENT_CLICK, toggleFilterPanel);
		addListener(dom.getSmallDeviceClosePanel(), EVENT_CLICK, toggleFilterPanel);
	}

	function renderLowaraCadCenterFeed(result) {
		dom.getDrawingResultElement().innerHTML = resultTemplate({ drawings: result.Drawings });
		const selectedFacets = dom.getSelectedCheckBoxes();

		if (selectedFacets.length === 0) {
			dom.getFacetContainer().innerHTML = facetGroupTemplate({ facetGroups: result.FacetGroups });
			styleCheckbox();
		}

		initEvents();

		updateClearAllBtn();
	}

	function addClearAllEvent() {
		addListener(dom.getClearFacetsContainerElement(), "click", () => {
			eventManager.trigger(events.search.FACET_CLEAR_ALL);
		});
	}

	function clearSelectedFacets() {
		unSelectCheckBoxes();
		eventManager.trigger(events.search.SEARCH);
	}

	function unSelectCheckBoxes() {
		const selectedFacets = dom.getSelectedCheckBoxes();

		selectedFacets.forEach((facet) => {
			const $input = facet.querySelector("input");
			unCheck($input);
		});
	}

	function updateClearAllBtn() {
		const enable = dom.getSelectedCheckBoxes().length;
		if (enable > 0) {
			addClearAllEvent();
		}
		dom.toggleClearFacetsButton(enable);
	}

	function filterToggle(e) {
		const $obj = e.currentTarget;
		const $outerGroup = getNextSibling(e.currentTarget, `.${CLASS_GROUP}`);

		if ($obj.nextElementSibling !== 0) {
			$obj.classList.toggle(CLASS_ICON_OPEN);
			$obj.classList.toggle(CLASS_ICON_CLOSED);
			$outerGroup.classList.toggle(classes.HIDDEN);
		}
	}

	function fetchResults() {
		const selectedFacets = dom.getSelectedCheckBoxes();
		let url = baseUrl;

		selectedFacets.forEach(function (e) {
			url += `&facets=${dom.getFacetValue(e)}`;
		});

		fetch(url)
			.then((response) => response.json())
			.then((result) => {
				if ($module.dataset.apiIsGoulds === "True") {
					renderGouldsFeed(result);
				} else {
					renderLowaraCadCenterFeed(result);
				}
				if (selectedFacets.length === 0 && result.Drawings.length === 0 && dom.getClearFacetsButton()) {
					dom.getClearFacetsButton().remove();
				}
			});
	}

	function toggleFilterPanel(e) {
		e.preventDefault();
		dom.getFacetContainer().classList.toggle(CLASS_OPEN);
	}

	function styleCheckbox() {
		const $checkBoxes = dom.getCheckboxes();
		styleCheckBoxes($checkBoxes);
	}

	function renderGouldsFeed(gouldstechnicaldrawing) {
		const html = dom.getGouldsResultTemplate({ gouldsTechnicalDrawing: gouldstechnicaldrawing });
		dom.getdownloadCadDropdown().append(html);
	}
}

export default {
	view: "productTechnicalDrawings",
	init,
};
